import { z } from "zod";

export const EMAIL_VALIDATION_ERROR = {
  invalid: "emailInvalid",
  reservedDomain: "emailReservedDomain",
} as const;

const SPECIAL_USE_DOMAINS = ["arpa", "invalid", "local", "localhost", "onion", "test"];

function hasSpecialUseDomain(email: string): boolean {
  const domain = email.slice(email.lastIndexOf("@") + 1).toLowerCase();
  return SPECIAL_USE_DOMAINS.some(
    (reservedDomain) => domain === reservedDomain || domain.endsWith(`.${reservedDomain}`),
  );
}

export const emailSchema = z
  .email({ error: EMAIL_VALIDATION_ERROR.invalid })
  .refine((email) => !hasSpecialUseDomain(email), {
    error: EMAIL_VALIDATION_ERROR.reservedDomain,
  });
